import React, { useEffect, useState } from "react";
import Wrapper from "components/ReusableComponents/Wrapper/Wrapper";
import tagOutline from "assets/images/tag-outline.svg";
import facebook from "assets/images/social-media/facebook-sm.svg";
import twitter from "assets/images/social-media/twitter-sm.svg";
import linkedin from "assets/images/social-media/linkedin-sm.svg";
import whatsApp from "assets/images/social-media/whatsapp-sm.svg";
import insta from "assets/images/social-media/insta-sm.svg";
import consumerProtection from "assets/images/consumer-protection.svg";
import Button from "components/ReusableComponents/Button/Button";
import Newsletter from "components/ReusableComponents/Newsletter/Newsletter";
import Layout from "components/Layout/Layout";
import { navigate } from "gatsby";
import Seo from "components/Seo";
const SocialMedia = () => {
  const [url, setUrl] = useState();

  useEffect(() => {
    if (typeof window !== undefined) {
      setUrl(window.location.href);
    }
  }, [url]);

  return (
    <div className="flex items-center gap-2">
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${
          typeof window !== "undefined" && url
        }`}
      >
        <img src={facebook} alt="facebook" />
      </a>
      <a
        href={`https://twitter.com/intent/tweet/?text=&url=${
          typeof window !== "undefined" && url
        }`}
      >
        <img src={twitter} alt="twitter" />
      </a>
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${
          typeof window !== "undefined" && url
        }`}
      >
        <img src={linkedin} alt="linkedin" />
      </a>
      {/* <a href="https://chat.whatsapp.com/F2kZ0EGNKoeEPBKDfyAEEX">
        <img src={whatsApp} alt="whatsApp" />
      </a>
      <a href="https://www.instagram.com/legalsection/">
        <img src={insta} alt="insta" />
      </a> */}
    </div>
  );
};

function BlogDetails(props) {
  const data = props.pageContext?.data || {};
  return (
    <Layout>
      <Seo
        title={`${data.title} | LegalSections`}
        description=""
        slug={`/blog/${data?.url_key}`}
      />
      <Wrapper>
        {/* <div className="w-8/12 mx-auto h-24 bg-[#FEECEC] border border-[#FF4F4F]"></div> */}
        <h1 className="text-4xl text-black xs:font-cairo font-semibold pt-10 pb-3 ">
          {data.title}
        </h1>
        <div className="text-base text-black xs:font-cairo inline-flex flex-col sm:flex-row items-start sm:items-center gap-3 pb-7">
          <div className="flex gap-3">
            <p className="font-semibold">{data.Author_name}</p>
            {/* <p>June 02, 2020</p> */}
            <p>{data.date}</p>
          </div>
          <div className="flex gap-3">
            <p className="text-primary border border-primary rounded-full inline-flex items-center gap-2 px-3 py-1">
              <img src={tagOutline} alt="category" />
              {data.news_category_name}
            </p>
            <SocialMedia />
          </div>
        </div>

        {data?.has_hindi_blog === 1 && (
          <div className="flex items-center gap-2 text-lg xs:font-cairo pb-10">
            <div className="bg-primary rounded-[10px] p-[6px] inline-flex items-center">
              <span
                className={`bg-white text-primary rounded-[10px] px-2 py-[1px] transition-colors duration-300 cursor-pointer 
                
                `}
                onClick={() => {
                  navigate(`/blog/${data?.url_key}`);
                }}
              >
                A
              </span>
              <span
                className={` text-white rounded-[10px] px-2 py-[1px] transition-colors duration-300 cursor-pointer 
                  `}
                onClick={() => {
                  navigate(`/hindi-blog/${data?.url_key}`);
                }}
              >
                ह
              </span>
            </div>
            <p>हिंदी में पढ़े</p>
          </div>
        )}
        <img src={data.cover_image} alt="banner" />
        <div className="pt-10 flex md:flex-row flex-col gap-x-7 ">
          <div
            dangerouslySetInnerHTML={{ __html: data.content }}
            className="blog-details text-black xs:font-cairo  "
          />
          <div className="flex flex-col gap-6">
            {/* <div className="w-72 mx-auto h-[600px] bg-[#FEECEC] border border-[#FF4F4F]"></div>
            <div className="w-72 mx-auto h-60 bg-[#FEECEC] border border-[#FF4F4F]"></div> */}
          </div>
        </div>

        <div className=" lg:max-w-[73%]  md:max-w-[60%]  py-14 flex flex-col items-center gap-4 text-cairo ">
          <p className="text-justify">
            Want to hear more from us then like, follow and subscribe
            LegalSections on{" "}
            <a
              href="https://www.facebook.com/LegalSections"
              className="font-medium"
            >
              Facebook
            </a>
            ,{" "}
            <a
              href="https://twitter.com/i/flow/login?redirect_after_login=%2FLegalSections"
              target="_blank"
              className="font-medium"
            >
              Twitter
            </a>
            ,{" "}
            <a
              href="https://www.linkedin.com/company/legalsections"
              target="_blank"
              className="font-medium"
            >
              LinkedIn
            </a>
            ,{" "}
            <a
              href="https://www.instagram.com/legalsection/"
              target="_blank"
              className="font-medium"
            >
              Instagram{" "}
            </a>{" "}
            and{" "}
            <a
              href="https://www.youtube.com/@legalsections6395"
              target="_blank"
              className="font-medium"
            >
              Youtube
            </a>
            .
          </p>
          <p className="text-justify font-bold">
            These articles are provided freely as general guides. Do not rely on
            information provided here without seeking expericed legal advice
            first. If in doubt, please always consult a lawyer.
          </p>
        </div>
        <SocialMedia />
        {/* comment form */}
        {/* <div className="py-8 md:w-9/12 lg:w-7/12">
          <p className="text-2xl text-black xs:font-cairo pb-6">Add comment</p>
          <form className="text-base text-black xs:font-cairo">
            <label className="text-primary block pb-2">Comment</label>
            <textarea
              placeholder="Write your Comment"
              className="bg-goldLight border border-primary outline-none rounded-lg min-h-[120px] w-full px-4 py-2"
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-5">
              <div>
                <label className="text-primary block pb-2">Name</label>
                <input
                  type="text"
                  placeholder="Enter your Name"
                  className="bg-goldLight border border-primary outline-none rounded-lg w-full px-4 py-2"
                />
              </div>
              <div>
                <label className="text-primary block pb-2">Email</label>
                <input
                  type="email"
                  placeholder="Enter your Email"
                  className="bg-goldLight border border-primary outline-none rounded-lg w-full px-4 py-2"
                />
              </div>
            </div>
            <Button
              variant="primary"
              title="Post Comment"
              className="rounded-lg"
            />
          </form>
        </div> */}
      </Wrapper>
      <Newsletter />
    </Layout>
  );
}
export default BlogDetails;
